import { api } from '@/services/api/axios/instance';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Article } from '@/types/article';

type ReturnType = {
  articles: Article[];
};

export const articlesApi = {
  getList: async (config: AxiosRequestConfig): Promise<ReturnType> => {
    const path = 'announcements/articles';

    const response: AxiosResponse = await api.get(path, config);
    return response.data;
  },
};
